import React from 'react';

import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';

import { FaceAdditionalInfo } from './face-additional-info';
import { FaceGeneralInfo } from './face-general-info';
import { FacePageHeader } from './face-page-header/FacePageHeader';
import st from './FacePage.module.sass';
import { SameExternalIdFacesSection, LatestFaceEventsSection, FaceParentEventSection } from './sections';
import { useFaceIdFromLocation } from './useFaceIdFromLocation';

export function FacePage(): React.JSX.Element {
  const faceId = useFaceIdFromLocation();

  return (
    <Page>
      <PageContent>
        <FacePageHeader faceId={faceId} />
        <div className={st.Root}>
          <div className={st.Info}>
            <FaceGeneralInfo faceId={faceId} />
            <FaceAdditionalInfo faceId={faceId} />
          </div>
          <div className={st.Body}>
            <SameExternalIdFacesSection faceId={faceId} />
            <LatestFaceEventsSection faceId={faceId} />
            <FaceParentEventSection faceId={faceId} />
          </div>
        </div>
      </PageContent>
    </Page>
  );
}
